import logo from 'assets/images/khula-logo-badge-green.svg';
import {Box, CircularProgress, Typography} from '@material-ui/core';
import React from 'react';

export function AppLoader() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <img src={logo} alt={'Khula! Supplier Dashboard'} style={{width: 400}} />
      <CircularProgress size={40} thickness={4} />
      <Box mt={1} />
      <Typography variant="subtitle1">Loading</Typography>
    </div>
  );
}
